import request, { FetchError } from '@/services/request';

export async function saveOnServerFile(scanType = null, file = null, description = '', year) {
  try {
    if (!scanType || !file) throw new Error('scanType && file invalid; cannot be null');
    const form = new FormData();
    form.append('file', file);
    const res = await request({
      endpoint: `/api/${year}/file/upload?scanType=${scanType}&description=${description}`,
      method: 'put',
      body: form,
    });
    if (res.status === 200 || res.status === 201) return res.data;
    else throw new Error('error saveFile');
  } catch (e) {
    console.error('error saveFile ' + e);
    throw new FetchError(e.response, e.body, e.message, e.status);
  }
}
export async function saveDataInFile(file, year, id) {
  try {
    if (!file) throw new Error(' file invalid; cannot be null');
    const form = new FormData();

    form.append('file', file);
    form.append('ownerId', id);
    const res = await request({
      endpoint: `/api/${year}/import/excel`,
      method: 'post',
      body: form,
    });
    if (res.status === 200 || res.status === 201) return res.data;
    else throw new Error('error saveDataInFile');
  } catch (e) {
    throw new Error(e.message);
  }
}

export async function getFile(id = null, year) {
  try {
    if (!id) throw new Error('id invalid; cannot be null');
    // const url = new URL('/api/file/download');
    // url.searchParams.append('file', id);
    const res = await request({
      endpoint: `/api/${year}/file/download?file=${id}`,
      method: 'get',
    });
    if (res.status === 200) return res.data;
    else throw new Error('error getFile');
  } catch (e) {
    console.error('error getFile ' + e);
    throw new FetchError(e.response, e.body, e.message, e.status);
  }
}
export async function getReport(path) {
  try {
    if (!path) throw new Error('path invalid; cannot be null');
    // const url = new URL('/api/file/download');
    // url.searchParams.append('file', id);
    const res = await request({
      endpoint: path,
      method: 'get',
    });
    if (res.status === 200) return res.data;
    else throw new Error('error getReport');
  } catch (e) {
    console.error('error getReport ' + e);
    throw new FetchError(e.response, e.body, e.message, e.status);
  }
}
export async function deleteFile(id = null, year) {
  try {
    if (!id) throw new Error('id invalid; cannot be null');
    const res = await request({
      endpoint: `/api/${year}/file/delete?fileId=${id}`,
      method: 'delete',
    });
    if (res.status === 200) return res.data;
    else throw new Error('error deleteFile');
  } catch (e) {
    console.error('error deleteFile ' + e);
    throw new FetchError(e.response, e.body, e.message, e.status);
  }
}

export async function getFileList(userType = '', userId = null, year) {
  try {
    let url = `/api/${year}/file/list`;
    if (userType) {
      if (!['orgID', 'regionID', 'founderID'].includes(userType))
        throw new Error('userType can be only orgID regionID founderID');
      if (!userId) throw new Error('userId cannot be null');
      url += '?userType=' + userType;
    }
    if (userId) url += '&userId=' + userId;
    const res = await request({
      endpoint: url,
      method: 'get',
    });
    if (res.status === 200) return res.data;
    else throw new Error('error getFileList');
  } catch (e) {
    console.error('error getFileList ' + e);
    throw new FetchError(e.response, e.body, e.message, e.status);
  }
}
